import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EvaluationStatusEnum from "./evaluationStatusEnum";
import useNavigateToLoginPageEnv from "./useNavigateToLoginPageEnv";
import Loading from "./loading";

const NewAttempt = ({ updateStatus, updateBeginOrNew }) => {
    const navigateToLoginPageEnv = useNavigateToLoginPageEnv();
    const navigate = useNavigate();
    const { courseCode, assessmentCode } = useParams();
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);

    const handleClick = async () => {
        if (requestLifeCycle) {
            return;
        }        
        
        try {
            setRequestLifeCycle(true);
            const response = await fetch( process.env.REACT_APP_EVALUATION_API_URL  + `/begin-new-attempt`, {
                method: "POST",
                credentials: "include",  
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify({
                    courseCode: courseCode,
                    assessmentCode: assessmentCode,
                    entryCode: ""
                })
            })
            const data = await response.json();

            // if correct -> take the eval
            if (response.status === 200) {
                localStorage.setItem(assessmentCode, "true");
                localStorage.setItem("didDismissLogging", "false");
                localStorage.setItem('blockPaste', 'true');
                navigate(`/${courseCode}/${assessmentCode}/take-evaluation`);
            // if has to begin -> set to begin
            } else if (response.status === 450) {
                updateStatus(EvaluationStatusEnum.BEGIN);
            // catch expected errors
            } else if (response.status === 451 || response.status === 452 || response.status === 455 || response.status === 456) {
                updateStatus(EvaluationStatusEnum.ERROR);
            // if has to enter entry code
            } else if (response.status === 453) {
                updateStatus(EvaluationStatusEnum.NOT_ENTERED_ENTRY_CODE);
                updateBeginOrNew("new");
            // auth
            } else if (response.status === 401) {
                navigateToLoginPageEnv();
            // if an autograder is running
            } else if (response.status === 460) {
                alert("At least one autograder is running. Wait 15 minutes or for autograding to finish.");
            // catch wild card errors
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
                updateStatus(EvaluationStatusEnum.ERROR);
            }
        } catch(error) {
            alert("Error: " + error.message);
            updateStatus(EvaluationStatusEnum.ERROR)
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }
    
    return (
        <>
            {
                requestLifeCycle

                ?

                <>
                    <div className="total-2">
                        <Loading />
                    </div>
                </>

                :
            
                <div className="top-right-item" onClick={() => {
                    // eslint-disable-next-line no-restricted-globals
                    const confirmed = confirm("A new attempt will delete all of your existing submission information including your score and answers. Are you sure you want to proceed?");

                    if (!confirmed) {
                        return;
                    }

                    handleClick();
                }} style={{ width: "160px", minWidth: "160px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1z"/>
                    </svg>
                    New Attempt
                </div>

            }
        </>
    );
}

export default NewAttempt;